// Mock-slide illustrations for the quick quiz type rows, 1:1 with the
// approved mockup's qt-* symbols. Drawn with currentColor on a panel plate.

interface IllProps {
	className?: string;
}

const base = (className?: string) => ({
	viewBox: '0 0 120 76',
	preserveAspectRatio: 'xMidYMid meet' as const,
	xmlns: 'http://www.w3.org/2000/svg',
	'aria-hidden': true as const,
	className,
});

export const QtStandard = ({ className }: IllProps) => (
	<svg {...base(className)}>
		<rect
			x='22'
			y='28'
			width='76'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.45'
		/>
		<rect
			x='32'
			y='42'
			width='56'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
	</svg>
);

export const QtAbcd = ({ className }: IllProps) => (
	<svg {...base(className)}>
		<text
			x='16'
			y='32'
			fontFamily='Fjalla One'
			fontSize='15'
			fill='currentColor'
			opacity='.7'
		>
			A
		</text>
		<rect
			x='26'
			y='20'
			width='30'
			height='9'
			rx='4.5'
			fill='currentColor'
			opacity='.2'
		/>
		<text
			x='16'
			y='58'
			fontFamily='Fjalla One'
			fontSize='15'
			fill='currentColor'
			opacity='.7'
		>
			B
		</text>
		<rect
			x='26'
			y='46'
			width='30'
			height='9'
			rx='4.5'
			fill='currentColor'
			opacity='.2'
		/>
		<text
			x='66'
			y='32'
			fontFamily='Fjalla One'
			fontSize='15'
			fill='currentColor'
			opacity='.7'
		>
			C
		</text>
		<rect
			x='76'
			y='20'
			width='30'
			height='9'
			rx='4.5'
			fill='currentColor'
			opacity='.2'
		/>
		<text
			x='66'
			y='58'
			fontFamily='Fjalla One'
			fontSize='15'
			fill='currentColor'
			opacity='.7'
		>
			D
		</text>
		<rect
			x='76'
			y='46'
			width='30'
			height='9'
			rx='4.5'
			fill='currentColor'
			opacity='.2'
		/>
	</svg>
);

export const QtConnection = ({ className }: IllProps) => (
	<svg {...base(className)}>
		<rect
			x='14'
			y='10'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='14'
			y='26'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='14'
			y='42'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='14'
			y='58'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='76'
			y='10'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='76'
			y='26'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='76'
			y='42'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<rect
			x='76'
			y='58'
			width='30'
			height='8'
			rx='4'
			fill='currentColor'
			opacity='.2'
		/>
		<path
			d='M48 14 72 46M48 30 72 62M48 46 72 14M48 62 72 30'
			stroke='currentColor'
			strokeWidth='1.6'
			opacity='.55'
			fill='none'
			strokeLinecap='round'
		/>
	</svg>
);

export const QtAssociation = ({ className }: IllProps) => (
	<svg {...base(className)}>
		{[10, 22].map((y) =>
			[14, 38, 62, 86].map((x) => (
				<rect
					key={`${x}-${y}`}
					x={x}
					y={y}
					width='20'
					height='7'
					rx='3.5'
					fill='currentColor'
					opacity='.2'
				/>
			))
		)}
		{['A', 'B', 'C', 'D'].map((letter, i) => (
			<text
				key={letter}
				x={21 + i * 24}
				y='46'
				fontFamily='Fjalla One'
				fontSize='11'
				fill='currentColor'
				opacity='.7'
			>
				{letter}
			</text>
		))}
		<rect
			x='14'
			y='56'
			width='92'
			height='9'
			rx='4.5'
			fill='currentColor'
			opacity='.45'
		/>
	</svg>
);

export const QtVisual = ({ className }: IllProps) => (
	<svg {...base(className)}>
		<rect
			x='26'
			y='9'
			width='68'
			height='6'
			rx='3'
			fill='currentColor'
			opacity='.45'
		/>
		<rect
			x='20'
			y='22'
			width='80'
			height='46'
			rx='6'
			fill='currentColor'
			opacity='.14'
		/>
		<circle
			cx='38'
			cy='36'
			r='5'
			fill='none'
			stroke='currentColor'
			strokeWidth='1.8'
			opacity='.6'
		/>
		<path
			d='M30 60l16-18 12 13 8-9 14 14'
			fill='none'
			stroke='currentColor'
			strokeWidth='1.8'
			opacity='.6'
			strokeLinejoin='round'
			strokeLinecap='round'
		/>
	</svg>
);
